import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { ResultShowcase } from '../components/sections/ResultShowcase';
import { YoutubeVsSystem } from '../components/sections/YoutubeVsSystem';
import { PainPoints } from '../components/sections/PainPoints';
import { RoadmapSection } from '../components/sections/RoadmapSection';
import { NoMoreSection } from '../components/sections/NoMoreSection';
import { WhatYouGet } from '../components/sections/WhatYouGet';
import { BonusSection } from '../components/sections/BonusSection';
import { TestimonialSection } from '../components/sections/TestimonialSection';
import { PricingSection } from '../components/sections/PricingSection';
import { GuaranteeSection } from '../components/sections/GuaranteeSection';
import { FaqSection } from '../components/sections/FaqSection';
export function SalesPage() {
  return <div className="min-h-screen bg-[#FDFCF8] font-sans selection:bg-teal-100 selection:text-teal-900" data-id="element-201">
      <HeroSection data-id="element-202" />
      <ResultShowcase data-id="element-203" />
      <YoutubeVsSystem data-id="element-204" />
      <PainPoints data-id="element-205" />
      <RoadmapSection data-id="element-206" />
      <NoMoreSection data-id="element-207" />
      <WhatYouGet data-id="element-208" />
      <BonusSection data-id="element-209" />
      <TestimonialSection data-id="element-210" />
      <PricingSection data-id="element-211" />
      <GuaranteeSection data-id="element-212" />
      <FaqSection data-id="element-213" />

      {/* Simple Footer */}
      <footer className="py-8 bg-stone-900 text-stone-500 text-center text-sm" data-id="element-214">
        <p data-id="element-215">
          &copy; {new Date().getFullYear()} Resin Without Errors. All rights
          reserved.
        </p>
      </footer>
    </div>;
}